module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MhEcEn/tc-custom/9781452150451.jpg?1705006395737",
      "alt": "This image is the cover for the book Grill Eats & Drinks"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Grill Eats & Drinks\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The essential recipes you need to establish the best grilling game on the block—from Grilled Pizza to Foolproof Burgers, Tequila-Lime Shrimp to Mojitos.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A taste of the good life! This bite-size collection showcases twenty special recipes, all with photographs, that will inspire food lovers to take the party outside. Selected from some of Chronicle Books’ best-loved cookbooks, here are easy-peasy drinks (alcoholic and nonalcoholic), quick appetizers, simple salads and sides, and great-for-the-grill main dishes. Whether it’s the South Seas Sangria, Corn with Chipotle Butter, or the Honey-Glazed Spareribs that beckon, everything tastes better out on the patio. And grilling will be all the more relaxing for the cook who has this just-right repertoire at hand. \n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Chronicle Books\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0